import { useCallback } from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { RecommendedSeller } from '../../types/seller';
import { useLandingPage } from '../context/LandingPageContext';
import { useSSE } from './useSSE';

export function useFetchGenerations() {
    const { setSellers, setGeneratedBrief, setIsMatchSellersLoading, setError } = useLandingPage();
    const { start, stop } = useSSE();

    const fetchGenerations = useCallback(
        (brief: string) => {
            setError(null);
            setIsMatchSellersLoading(true);
            const url = `${pathfinder('vibe_coding_get_generate_brief')}?prompt=${encodeURIComponent(brief)}`;
            start(url, {
                onMessage: (data) => {
                    if (data.type === 'sellersData') {
                        setIsMatchSellersLoading(false);
                        setSellers(data.sellers as RecommendedSeller[]);
                    } else if (data.type === 'brief') {
                        setGeneratedBrief(data.brief);
                    }
                },
                onFinish: () => {
                    stop();
                },
                onError: () => {
                    setError('Error fetching data');
                    stop();
                },
            });
        },
        [start, stop, setSellers, setGeneratedBrief, setIsMatchSellersLoading, setError]
    );

    return {
        fetchGenerations,
    };
}
